"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUserContentUrl = exports.getAppStoreURL = exports.getPusherAuthUrl = exports.getVendorBoothUrl = exports.getApiUrl = exports.getDashboardBaseUrl = exports.getBaseUrl = exports.getCDNUrl = exports.getGraphQLUrl = exports.getCreateEventUrl = exports.getLogoutUrl = exports.getLoginUrl = void 0;

var utils_1 = require("../utils");

exports.getLoginUrl = (0, utils_1.createGetEnvVar)({
  production: 'https://{events}/sign_in',
  staging: 'https://{events}/sign_in',
  local: 'http://localhost:3000/sign_in',
  review: 'https://{host}/sign_in'
}, 'login-url');
exports.getLogoutUrl = (0, utils_1.createGetEnvVar)({
  production: 'https://{events}/sign_out',
  staging: 'https://{events}/sign_out',
  local: 'http://localhost:3000/sign_out',
  review: 'https://{host}/sign_out'
}, 'logout-url');
exports.getCreateEventUrl = (0, utils_1.createGetEnvVar)({
  production: 'https://{events}/organizations/events/new',
  staging: 'https://{events}/organizations/events/new',
  local: 'http://localhost:3000/organizations/events/new',
  review: 'https://{host}/organizations/events/new'
}, 'create-event-url');
exports.getGraphQLUrl = (0, utils_1.createGetEnvVar)({
  production: 'https://graphql.events.ringcentral.com',
  staging: 'https://graphql.staging.events.ringcentral.com',
  local: 'http://localhost:4001',
  review: 'https://{branch}-graphql.ev-dev.hopininternal.com'
}, 'graphql-url');
exports.getCDNUrl = (0, utils_1.createGetEnvVar)({
  production: 'https://slices.static.events.ringcentral.com',
  staging: 'https://slices-dev.static.events.ringcentral.com',
  local: 'https://localhost:5000',
  review: 'https://slices-dev.static.events.ringcentral.com'
}, 'cdn-url');
exports.getBaseUrl = (0, utils_1.createGetEnvVar)({
  production: 'https://{events}',
  staging: 'https://{events}',
  local: 'http://localhost:3000',
  review: 'https://{host}'
}, 'base-url');
exports.getDashboardBaseUrl = (0, utils_1.createGetEnvVar)({
  production: 'https://{dashboard}',
  staging: 'https://{dashboard}',
  local: 'http://localhost:8000',
  // TODO: Update when review apps available for dashboard
  review: 'https://{host}'
}, 'dashboard-base-url');
exports.getApiUrl = (0, utils_1.createGetEnvVar)({
  production: 'https://{events}/api',
  staging: 'https://{events}/api',
  local: 'http://localhost:3000/api',
  review: 'https://{host}/api'
}, 'api-url');
exports.getVendorBoothUrl = (0, utils_1.createGetEnvVar)({
  production: 'https://{events}/vendors/booths',
  staging: 'https://{events}/vendors/booths',
  local: 'http://localhost:3000/vendors/booths',
  review: 'https://{host}/vendors/booths'
}, 'vendor-booth-url');
exports.getPusherAuthUrl = (0, utils_1.createGetEnvVar)({
  production: 'https://{events}/api/v2/pusher/auth',
  staging: 'https://{events}/api/v2/pusher/auth',
  local: 'http://localhost:3000/api/v2/pusher/auth',
  review: 'https://{host}/api/v2/pusher/auth'
}, 'pusher-auth');
exports.getAppStoreURL = (0, utils_1.createGetEnvVar)({
  production: 'https://{apps}',
  staging: 'https://{apps}',
  local: 'https://{apps}',
  review: 'https://dev.apps.staging.hopin.com'
}, 'apps-store-url');
exports.getUserContentUrl = (0, utils_1.createGetEnvVar)({
  production: 'https://usercontent.events.ringcentral.com',
  staging: 'https://usercontent.staging.events.ringcentral.com',
  local: 'https://usercontent.staging.events.ringcentral.com',
  review: 'https://usercontent.staging.events.ringcentral.com'
}, 'user-content-url');